import { trackEvent } from "@faire/web--source/common/trackEvent";
import { trackRetailerMobileCloseBottomNavClick } from "@faire/web-api--source/events/retailerMobile/click/closeBottomNav";
import { trackRetailerMobileBottomNavView } from "@faire/web-api--source/events/retailerMobile/view/bottomNav";
export var topNavEvent = function(name, retailerToken) {
    return function() {
        trackEvent("/retailer/".concat(retailerToken, "/top-nav/").concat(name));
        if (name === "open") {
            trackRetailerMobileBottomNavView();
        } else if (name === "close") {
            trackRetailerMobileCloseBottomNavClick();
        }
    };
};
